import React from "react";
import ArtList from "./Art/ArtList";

const Explore = () => {
  return (
    <>
      <ArtList />
    </>
  );
};

export default Explore;
